import React, { useEffect, useState } from "react";
import "./App.css";
import Layout from "./Layout/Layout";
import { BrowserRouter } from "react-router-dom";
import { Route } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

import { ThemeProvider } from "@material-ui/core/styles";
import { darkTheme, lightTheme } from "./Config/materialUiTheme";

import Home from "./Containers/Dashboard/Dashboard";
import Stake from "./Containers/Stake/Stake";
import Unstake from "./Containers/Unstake/Unstake";
import Notify from "./Components/Common/notify/Notify";

import {
  onGetIsUnlock,
  LogoutAppAction as StakeReducerReset,
} from "./store/actions/stakeActions";
import {
  checkWeb3,
  checkWeb3React,
  web3React,
  onToast,
  LogoutAppAction as LayoutReducerReset,
} from "./store/actions/layoutActions";
import {
  onGetTotalStakedToken,
  LogoutAppAction as DashboardReducerReset,
} from "./store/actions/dashboardActions";
import { LogoutAppAction as UnstakeReducerReset } from "./store/actions/unstakeActions";

import { Web3ReactProvider } from "@web3-react/core";
import { Web3Provider } from "@ethersproject/providers";
import { useWeb3React } from "@web3-react/core";
import { InjectedConnector } from "@web3-react/injected-connector";
import Web3 from "web3";
import { toast } from "react-toastify";

export const injectedConnector = new InjectedConnector({
  supportedChainIds: [1, 3, 4, 5, 42],
});

const web3 = new Web3(Web3.givenProvider);

function getLibrary(provider) {
  const library = new Web3Provider(provider);
  library.pollingInterval = 12000;
  return library;
}

const Account = async () => {
  // console.log("Account running");

  const { account, chainId } = useWeb3React();
};

function App({
  address,
  network,
  checkWeb3,
  checkWeb3React,
  onGetIsUnlock,
  stateThemeMode,
  onGetTotalStakedTokens,
}) {
  const dispatch = useDispatch();
  const [themeMode, setThemeMode] = useState(localStorage.getItem("themeMode"));
  const [authenticated, setAuthenticated] = useState(true);

  const myThemeMode = localStorage.getItem("themeMode");

  // console.log("App theme Mode", myThemeMode);
  // console.log("Redux theme Mode", stateThemeMode);

  const refreshCheck = localStorage.getItem("themeMode");
  if (refreshCheck) {
    // console.log("themeMode already set");
  } else {
    localStorage.setItem("themeMode", "light");
    setThemeMode("light");
  }
  const loading = () => {
    let password = prompt("Enter Password");

    if (password === process.env.REACT_APP_PASSWORD) {
      setAuthenticated(true);
    } else {
      // alert("Wrong Password Try Again");
    }
  };

  const toggleThemeMode = () => {
    if (themeMode === "dark") {
      localStorage.setItem("themeMode", "light");
    } else {
      localStorage.setItem("themeMode", "dark");
    }
    setThemeMode(localStorage.getItem("themeMode"));
  };

  const onConnect = async () => {
    let ethereum = window.ethereum;
    if (!ethereum || !ethereum.isMetaMask) {
      // throw new Error('Please install MetaMask.')
      // alert(`METAMASK NOT INSTALLED!!`);
    } else {
      await ethereum.enable();
      checkWeb3();
    }
  };

  useEffect(() => {
    let timer;
    if (address) {
      // console.log("Checking approval in app.js");
      onGetIsUnlock(address);
    }
  }, [address]);

  useEffect(() => {
    // console.log("App.js rerendered");
    let ethereum = window.ethereum;
    if (ethereum) {
      ethereum.on("accountsChanged", checkWeb3);
      ethereum.enable();
      // checkWeb3();
      onGetTotalStakedTokens();
    }

    return () => {
      if (ethereum && ethereum.removeListener) {
        ethereum.removeListener("accountsChanged", checkWeb3);
      }
    };
  }, []);

  // Network refresh
  useEffect(() => {
    // console.log("Network here", network);
    if (network) {
      let localNetworkId = window.localStorage.getItem("networkId");
      if (network && (network !== null || network != "")) {
        if (String(network) != String(localNetworkId)) {
          window.localStorage.setItem("networkId", network);
          if (localNetworkId && network) {
            // checkWeb3({ address: address, network: network });
            checkWeb3();
            if (network != 1) {
              toast(
                <Notify
                  text="Please Switch to main network"
                  severity="success"
                />,
                {
                  position: "bottom-right",
                }
              );
            }
          }
        }
      }
    }
  }, [network]);

  // useEffect(() => {
  //   if (network) {
  // console.log("networkk", network);
  // if (network != 1) {
  // dispatch(onToast("Please Switch to main network."));
  // toast(
  //   <Notify text="Please Switch to main network" severity="success" />,
  //   {
  //     position: "bottom-right",
  //   }
  // );
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (network != 1) {
      dispatch(StakeReducerReset());
      dispatch(UnstakeReducerReset());
      dispatch(LayoutReducerReset());
      dispatch(DashboardReducerReset());
    }
    // console.log("network11", network, typeof network);
  }, [network]);

  // Address refresh
  // useEffect(() => {
  //   let addresss = localStorage.getItem("localaddress");
  //   if (address && (address != null || address != "")) {
  //     setInterval(() => {
  //       if (String(address.toLowerCase()) != String(addresss)) {
  //         localStorage.setItem("localaddress", address.toLowerCase());
  //         if (addresss && address) {
  //           // console.log("LocalAddress reload");
  //           // window.location.reload();
  //         }
  //       }
  //     }, 2000);
  //   }
  // }, [address]);

  return authenticated ? (
    <Web3ReactProvider getLibrary={getLibrary}>
      {/* <Wallet /> */}
      <ThemeProvider theme={stateThemeMode === "dark" ? darkTheme : lightTheme}>
        <BrowserRouter>
          <Layout>
            <Route exact path="/" component={Home} />
            <Route exact path="/stake" component={Stake} />
            <Route exact path="/unstake" component={Unstake} />
          </Layout>
        </BrowserRouter>
      </ThemeProvider>
    </Web3ReactProvider>
  ) : (
    <div>{loading()}</div>
  );
}

const mapStateToProps = (state) => {
  return {
    address: state.layoutReducer.address,
    network: state.layoutReducer.network,
    stateThemeMode: state.layoutReducer.themeMode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkWeb3: () => dispatch(checkWeb3()),
    onGetIsUnlock: (address) => dispatch(onGetIsUnlock(address)),
    onGetTotalStakedTokens: () => dispatch(onGetTotalStakedToken()),
    checkWeb3React: (load) => dispatch(checkWeb3React(load)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
